import React from "react";
import style from "./style.module.css";

export function Footer() {
    return (
        <footer className={style.footer}>
            <span className={style.title}>pnnl mhci capstone 2021</span>
        </footer>
    )
}